<template>
	<div class="filter quality">
		<div class="filter-item">
			<span @click="filterType = 'to_plan'; currentFilter = 'quality/to_plan/week'; emitFilterChange('quality/to_plan/week')">Nog te plannen</span>
			<ToggleField
				type="radio"
				name="filterType"
				:checked="filterType === 'to_plan'"
				@change="filterType = 'to_plan'; currentFilter = 'quality/to_plan/week'; emitFilterChange('quality/to_plan/week')"
			/>
		</div>
		<div class="filter-item">
			<span @click="filterType = 'appointments'; currentFilter = 'quality/appointments/all'; emitFilterChange('quality/appointments/all')">Afspraken</span>
			<ToggleField
				type="radio"
				name="filterType"
				:checked="filterType === 'appointments'"
				@change="filterType = 'appointments'; currentFilter = 'quality/appointments/all'; emitFilterChange('quality/appointments/all')"
			/>
		</div>
		<div class="filter-item">
			<span @click="filterType = 'historic'; currentFilter = 'quality/historic'; emitFilterChange('quality/historic')">Verleden</span>
			<ToggleField
				type="radio"
				name="filterType"
				:checked="filterType === 'historic'"
				@change="filterType = 'historic'; currentFilter = 'quality/historic'; emitFilterChange('quality/historic')"
			/>
		</div>
		<h1 class="thermo">FILTERS</h1>
		<div v-if="filterType === 'to_plan'">
			<div class="filter-item">
				<span @click="emitFilterChange('quality/to_plan/week')">Week</span>
				<ToggleField
					type="radio"
					name="filter"
					:checked="currentFilter === 'quality/to_plan/week'"
					@change="emitFilterChange('quality/to_plan/week')"
				/>
			</div>
			<div class="filter-item">
				<span @click="emitFilterChange('quality/to_plan/two-weeks')">14 Dagen</span>
				<ToggleField
					type="radio"
					name="filter"
					:checked="currentFilter === 'quality/to_plan/two-weeks'"
					@change="emitFilterChange('quality/to_plan/two-weeks')"
				/>
			</div>
			<div class="filter-item">
				<span @click="emitFilterChange('quality/to_plan/month')">Maand</span>
				<ToggleField
					type="radio"
					name="filter"
					:checked="currentFilter === 'quality/to_plan/month'"
					@change="emitFilterChange('quality/to_plan/month')"
				/>
			</div>
			<div class="filter-item">
				<span @click="emitFilterChange('quality/to_plan/quarter')">Kwartaal</span>
				<ToggleField
					type="radio"
					name="filter"
					:checked="currentFilter === 'quality/to_plan/quarter'"
					@change="emitFilterChange('quality/to_plan/quarter')"
				/>
			</div>
			<div class="filter-item">
				<span @click="emitFilterChange('quality/to_plan/half-year')">Halfjaar</span>
				<ToggleField
					type="radio"
					name="filter"
					:checked="currentFilter === 'quality/to_plan/half-year'"
					@change="emitFilterChange('quality/to_plan/half-year')"
				/>
			</div>
			<div class="filter-item">
				<span @click="emitFilterChange('quality/to_plan/all')">Alles</span>
				<ToggleField
					type="radio"
					name="filter"
					:checked="currentFilter === 'quality/to_plan/all'"
					@change="emitFilterChange('quality/to_plan/all')"
				/>
			</div>
		</div>
		<div v-if="filterType === 'appointments'">
			<div class="filter-item">
				<span @click="emitFilterChange('quality/appointments/all')">Alle afspraken</span>
				<ToggleField
					type="radio"
					name="filter"
					:checked="currentFilter === 'quality/appointments/all'"
					@change="emitFilterChange('quality/appointments/all')"
				/>
			</div>
			<div
				v-for="day in daysOfTheWeek"
				:key="day.value"
				class="filter-item"
			>
				<span @click="emitFilterChange(`quality/appointments/${day.value}`)">{{ day.name }}</span>
				<ToggleField
					type="radio"
					name="filter"
					:checked="currentFilter === `quality/appointments/${day.value}`"
					@change="emitFilterChange(`quality/appointments/${day.value}`)"
				/>
			</div>
		</div>
		<div v-if="filterType === 'historic'">
			Van <DateField v-model="historicFromDate" :maximum-allowed-date="getHistoricTillDate" @change="emitFilterChange(currentFilter)" value-format="yyyy-mm-dd"></DateField>
			T/m <DateField v-model="historicTillDate" :minimum-allowed-date="getHistoricFromDate" :maximum-allowed-date="dateYesterday" @change="emitFilterChange(currentFilter)" value-format="yyyy-mm-dd"></DateField>
		</div>
	</div>
</template>

<script>
import ToggleField from "@/components/ToggleField.vue";
import DateField from "@/components/DateField.vue";
import moment from "moment";

export default {
	components: {
		ToggleField,
		DateField
	},

	props: {
		filter: String
	},
	watch: {
		filter() {
			if(this.filter === this.currentFilter){
				return;
			}
			this.currentFilter = this.filter;
			this.emitFilterChange(this.filter);
		}
	},

	data() {
		return {
			filterType: "to_plan",
			agentFilter: null,
			currentFilter: "quality/to_plan/week",
			afterDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
			historicFromDate: moment().subtract(6, "months").format("YYYY-MM-DD"),
			historicTillDate: moment().subtract(1, 'days').format("YYYY-MM-DD"),
			dateYesterday: new Date(),
		};
	},

	mounted() {
		this.emitFilterChange(this.currentFilter);
	},

	computed: {
		getHistoricFromDate() {
			return new Date(this.historicFromDate);
		},
		getHistoricTillDate() {
			return new Date(this.historicTillDate);
		},

		daysOfTheWeek() {
			const days = [];

			for (let i = 0; i < 7; i++) {
				const day = moment().locale("nl").add(i, "day");
				const dayName = day.format("dddd");

				if (["zaterdag", "zondag"].indexOf(dayName) === -1) {
					days.push({
						name: dayName.charAt(0).toUpperCase() + dayName.slice(1),
						value: day.format("YYYY-MM-DD")
					});
				}
			}

			return days;
		}
	},

	methods: {
		emitFilterChange(filter) {
			this.currentFilter = filter;
			this.$emit('filterChange', {
				filter: this.currentFilter,
				afterDate: this.afterDate,
				historicFromDate: this.historicFromDate,
				historicTillDate: this.historicTillDate
			});
		}
	}

};
</script>

<style scoped lang="scss">
.filter-item {
	display: flex; justify-content: space-between; margin-bottom: 0.5em;
}
</style>
